type AssistanceProps = {
  item: string;
  residential: {
    light: boolean;
    plus: boolean;
    premium: boolean;
  };
  business: {
    light: boolean;
  };
};

export const assistances: AssistanceProps[] = [
  {
    item: 'Encanador',
    residential: {
      light: true,
      plus: true,
      premium: true
    },
    business: {
      light: true
    }
  },
  {
    item: 'Desentupidor',
    residential: {
      light: true,
      plus: true,
      premium: true
    },
    business: {
      light: true
    }
  },
  {
    item: 'Chaveiro',
    residential: {
      light: true,
      plus: true,
      premium: true
    },
    business: {
      light: true
    }
  },
  {
    item: 'Eletricista',
    residential: {
      light: true,
      plus: true,
      premium: true
    },
    business: {
      light: true
    }
  },
  {
    item: 'Linha branca (eletrodoméstico)',
    residential: {
      light: false,
      plus: true,
      premium: true
    },
    business: {
      light: false
    }
  },
  {
    item: 'Linha marrom (eletrônicos)',
    residential: {
      light: false,
      plus: false,
      premium: true
    },
    business: {
      light: false
    }
  }
];
